import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/index';
type Backdrop = {
    open: boolean;
};
const initialState = {
    open: false,
};

const backdropSlice = createSlice({
    name: 'backdrop',
    initialState,
    reducers: {
        openBackdrop: (state, action: PayloadAction<Backdrop>) => {
            state.open = action.payload.open;
        },
        closeBackdrop: (state) => {
            state.open = false;
        },
    },
});

export const { openBackdrop, closeBackdrop } = backdropSlice.actions;

export const selectWithdrawalDialogOptions = (state: RootState) =>
    state.backdropSlice;

export default backdropSlice.reducer;
